var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-base__title step-name"},[_vm._v("Опись документов")]),_c('AttachDocumentMultiple',{attrs:{"documents":_vm.documents,"disabled":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }